import React from "react";
import useRolesVisibility from "../../../../common/roles/useRolesVisibility";
import { RequiredRoles } from "../../../../search/criteria/components/common/requiredRoles";

interface RestrictedTextProps {
	restrictionCode: string;
	missingRoles?: string[] | null;
}

export function RestrictedText({
	restrictionCode,
	missingRoles = null,
}: RestrictedTextProps) {
	const { hasRequiredRoles } = useRolesVisibility(
		RequiredRoles.showFor(["_USER"]),
	);

	const link = hasRequiredRoles
		? "/account-management/subscription"
		: "/subscribe";

	const getRestrictedText = () => {
		const defaultText =
			"This article is only available with a subscription for";

		if (missingRoles) {
			const rolesDescriptions = missingRoles.join(" and ");
			return (
				<>
					{defaultText} <a href={link}>{rolesDescriptions}</a>.
				</>
			);
		}

		switch (restrictionCode) {
			case "routes":
				return (
					<>
						Articles about route network updates are available for{" "}
						<a href={link}>
							Commercial Aviation Operator Schedule Data
							subscribers.
						</a>
					</>
				);
			case "particulars_ownership":
				return `${defaultText} Commercial Aviation Aircraft Ownership Data.`;
			case "particulars_contacts":
			case "particulars":
				return `${defaultText} Commercial Aviation Operator Contact Data.`;
			case "pro_both_segments":
				return (
					<>
						{defaultText}{" "}
						<a href={link}>
							Commercial Aviation News, Operator & Airport Data or
							Business Jet News
						</a>
						.
					</>
				);
			case "pro_business":
				return (
					<>
						{defaultText} <a href={link}>Business Jet News</a>.
					</>
				);
			case "pro_commercial":
			default:
				return (
					<>
						{defaultText}{" "}
						<a href={link}>
							Commercial Aviation Operator News, Operator &
							Airport Data
						</a>
						.
					</>
				);
		}
	};

	const tryNowButton = !hasRequiredRoles && (
		<a href="/subscribe" className="btn btn--secondary">
			Try now
		</a>
	);
	const loginButton = !hasRequiredRoles && (
		<a href="/login?od=" className="btn btn--secondary">
			Sign in
		</a>
	);

	return (
		<div className="post__restricted">
			<p>{getRestrictedText()}</p>

			<div className="btn-group">
				<a
					href={
						hasRequiredRoles
							? "/account-management/subscription"
							: "/products/operator-news"
					}
					className="btn btn--primary"
					aria-label="Find out more about subscription"
				>
					Find out more
				</a>
				{tryNowButton}
				{loginButton}
			</div>
		</div>
	);
}
